<template>
  <fragment>
    <page-head
      small
      title="صفحة الطلب"
      show-back
    >
      <div class="head-wings">
        <div
          v-show="$vuetify.breakpoint.lgAndUp"
          class="wing"
        >
          <naj-stepper
            :current-step="currentStepBasedOnMode"
            :steps="steps"
          ></naj-stepper>
        </div>

        <div :class="['wing r-info', {'not-new-mode': !isNewMode}]">
          <request-info v-if="!isNewMode"></request-info>
          <naj-button
            v-if="showDraftButton"
            primary
            @click="handleSaveDraftLawsuit()"
          >
            <v-icon
              class="icon"
              left
            >
              mdi-content-save
            </v-icon>
            حفظ كمسودة
          </naj-button>

          <naj-modal
            ref="confirmModal"
            title="هل أنت متأكد؟"
            width="500"
            persistent
            show-footer-close-button
          >
            <p class="h4">
              هل أنت متأكد أنك تريد الحفظ كمسودة؟
            </p>

            <template
              slot="actions"
              slot-scope="{ closeNajModal }"
            >
              <naj-button @click="handleSaveDraftLawsuit(closeNajModal)">
                حفظ
              </naj-button>
            </template>
          </naj-modal>

          <naj-modal
            ref="confirmContinueModal"
            title="هل تريد المتابعة"
            width="500"
            persistent
            footer
          >
            <p class="h4">
              تم حفظ الطلب كمسودة برقم {{ activeRequestCode }} بنجاح، هل تود المتابعة أم العودة؟
            </p>

            <template
              slot="actions"
              slot-scope="{ closeNajModal }"
            >
              <naj-button @click="$router.push({ path: '/' })">
                الخروج
              </naj-button>
              <naj-button @click="handleContinue(closeNajModal)">
                المتابعة
              </naj-button>
            </template>
          </naj-modal>
        </div>
      </div>
    </page-head>

    <page-content small>
      <step-case-category v-if="currentStepBasedOnMode === 0 || currentStepBasedOnMode === 1"></step-case-category>
      <step1 v-if="currentStepBasedOnMode === 2"></step1>
      <step2 v-if="currentStepBasedOnMode === 3"></step2>
      <step3 v-if="currentStepBasedOnMode === 4"></step3>

      <template v-if="!isNewMode">
        <request-incomplete-reasons :request-object-key="requestObjectKey"></request-incomplete-reasons>
        <request-reasons :request-object-key="requestObjectKey"></request-reasons>
      </template>
    </page-content>
  </fragment>
</template>

<script>
import stepCaseCategory from '../components/step-case-category/index';
import Step1 from '../components/step1/index';
import Step2 from '../components/step2/index';
import Step3 from '../components/step3/index';
import RequestInfo from '../components/request-info/index';
import { requestStatus } from '@/helpers/enum';
import RequestIncompleteReasons from '../components/request-incomplete-reasons/index';
import RequestReasons from '../components/request-reasons/index';
// import StickyActions from '../components/sticky-actions/index';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapGetters, mapActions } = createNamespacedHelpers(
  'LawsuitModule'
);

export default {
  reactiveProvide: {
    name: 'mode',
    include: ['isViewMode'],
  },
  components: {
    stepCaseCategory,
    Step1,
    Step2,
    Step3,
    RequestInfo,
    RequestIncompleteReasons,
    RequestReasons,

    // stickyActions,
  },
  data() {
    return {
      requestStatus,
      activeObjectKey: null,
      activeRequestCode: null,
    };
  },
  computed: {
    ...mapState(['currentStep', 'submittedRequestInfo']),
    ...mapGetters(['isNewMode', 'isViewMode', 'isEditMode']),
    steps() {
      return [
        { title: 'تصنيف الدعوى' },
        { title: 'أطراف الدعوى' },
        { title: 'موضوع الدعوى' },
        { title: 'المرفقات' },
      ].filter(s => !s.disabled);
    },
    showDraftButton() {
      const hideFromSteps = [0, 1];
      return this.isNewMode && hideFromSteps.indexOf(this.currentStepBasedOnMode) === -1;
    },
    currentStepBasedOnMode() {
      return this.currentStep + 1;
    },
    stepParam() {
      return this.$route.params.step - 1;
    },
    objectKey() {
      return this.$route.params.objectKey;
    },
  },
  methods: {
    ...mapActions(['currentStepChanged', 'openLawsuit', 'saveDraftLawsuit']),
    handleSaveDraftLawsuit(closeModal) {
      if (closeModal) {
        closeModal();
        this.saveDraftLawsuit()
          .then(({ data }) => {
            this.activeObjectKey = data.objectKey;
            this.activeRequestCode = data.requestCode;

            this.$refs.confirmContinueModal.show();
          });
      } else {
        this.$refs.confirmModal.show();
      }
    },
    handleContinue(closeModal) {
      closeModal();

      this.$router.push({ path: `/lawsuit-requests/${this.activeObjectKey}/${this.currentStep + 1}` });
    },
  },
  watch: {
    stepParam: function (step) {
      this.currentStepChanged(step);
    },
    objectKey: function (objectKey) {
      this.openLawsuit({
        currentStep: this.stepParam || 0,
        objectKey,
      });
    },
  },
  created() {
    this.openLawsuit({
      currentStep: this.stepParam || 0,
      objectKey: this.objectKey,
    });
  },
};
</script>

<style lang="scss" scoped>
.head-wings {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .r-info {
    margin-left: 40px;
  }

  .not-new-mode {
    margin-left: 10px;
    margin-top: -45px;

    &::v-deep {
      .request-info-root {
        background-color: var(--app-light-secondary-color);
        padding: 10px 20px;
        border-radius: 5px;
        border: 1px solid var(--app-primary-color);

        > div {
          min-width: 170px;

          > b {
            display: flex;
            width: 100%;
            justify-content: space-between;
            font-weight: 700;
            margin-bottom: 5px;

            > span {
              margin-right: 0;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
